import { StyleSheet } from 'react-native'
import theme from '../../../../theme'

const styles = StyleSheet.create({
    container: {
        paddingVertical: 10,
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 15,
        paddingTop: 5,
        paddingBottom: 8,
    },
    image: {
        marginLeft: 10,
        width: 80,
        height: 80,
    },
    input: {
        height: 40,
        borderWidth: StyleSheet.hairlineWidth,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 0,
        paddingHorizontal: 10,
        marginHorizontal: 12,
        marginBottom: 0,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    inputWithMargin: {
        height: 40,
        borderWidth: StyleSheet.hairlineWidth,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 0,
        paddingHorizontal: 10,
        marginHorizontal: 15,
        marginBottom: 5,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    inputDropdownMenuSubsection: {
        borderWidth: StyleSheet.hairlineWidth,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    mainWrapper: {
        marginTop: 4,
        marginHorizontal: 0,
    },
    searchInput: {
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        fontSize: 14,
        paddingVertical: 10,
        paddingHorizontal: 12,
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
        borderRadius: 5,
    },
    itemsContainer: {
        borderWidth: StyleSheet.hairlineWidth,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        marginHorizontal: 12,
        paddingVertical: 8,
        backgroundColor: 'white',
    },
    listContainer: {
        borderWidth: 0,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
    },
    rowList: {
        paddingVertical: 4,
        paddingHorizontal: 12,
    },
    indicator: {
        color: theme.colors.colorPrimary,
        top: -4,
        right: -8,
    },
    textTag: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.textPrimary,
    },
    textPlaceholder: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.mediumGray,
        paddingHorizontal: 12,
    },
    dropdown: {
        borderWidth: StyleSheet.hairlineWidth,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.lightGray,
        marginTop: -5,
        marginHorizontal: 15,
        marginBottom: 5,
    },
    dropdownOptions: {
        color: theme.colors.textPrimary,
    },
    dropdownInput: {
        fontSize: 15,
        color: theme.colors.mediumGray,
    },
    selectedContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginVertical: 8,
        marginHorizontal: 12,
    },
    hiddenInput: {
        color: 'transparent', // Oculta el texto en el input
        backgroundColor: 'transparent',
    },
    dropdownTextHighlight: {
        display: 'none', // Oculta la etiqueta "Selected"
    },
    badge: {
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
        borderRadius: 8,
        backgroundColor: 'white',
        padding: 5,
        margin: 4,
        flexDirection: 'row', // Para alinear el texto y el ícono horizontalmente
        alignItems: 'center', // Alinear verticalmente al centro
    },
    badgeText: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        marginHorizontal: 5,
    },
    badgeIcon: {
        marginLeft: 5, // Espacio entre el icono y el borde del badge
    },
    dropdownInputSelected: {
        fontSize: 15,
        color: theme.colors.textPrimary,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    marginHorizontal: {
        marginHorizontal: 12,
    },
    disabledDropdown: {
        borderColor: 'transparent',
        backgroundColor: 'transparent',
        marginTop: -5,
    },
    disabledOptionText: {
        color: theme.colors.textPrimary,
        opacity: 0.5, // Reduce la opacidad para indicar que está deshabilitado
    },
})
export default styles
